"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCreditRefined = void 0;
const buildCreditRefined = (credit) => {
    return {
        ID: credit.ID,
        metadata: {
            created: credit.metadata.created,
            updated: credit.metadata.updated,
        },
        subjects: credit.subjectsAwarded?.values.map((subject) => ({ ID: subject })) ?? [],
        credentials: credit.credentialsUsed?.values.map((credential) => ({ ID: credential })) ?? [],
        status: credit.status,
        oneOff: credit.oneOff,
        application: credit.application,
        precedent: credit.precedent,
        articulation: credit.articulation,
        precedentSuggestion: credit.precedentSuggestion,
        rejected: credit.rejected,
        conflicts: credit.conflictingWith?.values.map((value) => value) ?? [],
    };
};
exports.buildCreditRefined = buildCreditRefined;
//# sourceMappingURL=CreditRefined.js.map